import React from 'react'

const NoMatch = () => {
  return <div>404 Page not found!</div>
}

export default NoMatch
